import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LmsService } from "../../_Lms/services/lms.service";

declare var $: any;
@Component({
    selector: "app-group-ratio-master",
    templateUrl: "./group-ratio-master.component.html",
    styleUrls: ["./group-ratio-master.component.scss"],
    standalone: false
})
export class GroupRatioMasterComponent implements OnInit {
  private data: any;
  private _MasterService;
  showSpinner: boolean = false;
  dataSource: any;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("f") form: NgForm;
  showdropdown: boolean = false;

  groupDropdown: any[] = [];
  displayedColumns: string[] = [
    "Id",
    "Group_Ratio_Name",
    "Group_Names",
    "Account_Names",
    "EditAction",
  ];
  AccountHeadDropdown: any[] = [];

  // Selected values arrays
  selectedGroups: any[] = [];
  selectedAccountHeads: any[] = [];

  // Dropdown settings
  groupDropdownSettings: any;
  accountHeadDropdownSettings: any;
  groupRationame: string = "";
  modelId: any = 0;
  negativeid: any;
  currentUser: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private lmsService: LmsService
  ) {
    this._MasterService = MasterService;
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Group Ratio Master");
    this.initializeDropdownSettings();
    this.ACC_Get_Group_Ratio_Master();
    this.Get_Acc_GroupDropdown();
    this.getAccounthead();
  }

  initializeDropdownSettings() {
    this.groupDropdownSettings = {
      singleSelection: false,
      idField: "GroupId",
      textField: "Group_Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };

    this.accountHeadDropdownSettings = {
      singleSelection: false,
      idField: "AccountId",
      textField: "Account_Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
  }

  ACC_Get_Group_Ratio_Master() {
    this.showSpinner = true;
    this._MasterService.ACC_Get_Group_Ratio_Master().subscribe((result) => {
      console.log(result);
      this.showSpinner = false;
      this.dataSource = new MatTableDataSource(
        JSON.parse(JSON.stringify(result))
      );
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  OnClose() {
    $("#EditGroupRatioModal").modal("hide");
    this.resetForm();
  }

  onEdit(row) {
    $("#EditGroupRatioModal").modal("show");
    $("#EditGroupRatioModal").css("z-index", "1050");
    this.Get_Acc_GroupDropdown();
    this.getAccounthead();
    this.modelId = row.Id;
    this.negativeid = row.GroupIds;
    this.groupRationame = row.Group_Ratio_Name;
    // this.selectedAccountHeads = row.Account_Names;
    if (row.GroupIds < 0) {
      this.showdropdown = true;
    } else {
      this.showdropdown = false;
    }

    // If you have the actual IDs from the row, you can pre-populate like this:
    // Assuming row has GroupIds and AccountIds as comma-separated strings
    if (row.GroupIds) {
      const groupIdArray = row.GroupIds.split(",");
      this.selectedGroups = this.groupDropdown.filter((group) =>
        groupIdArray.includes(group.GroupId.toString())
      );
    }

    if (row.AccountIds) {
      const accountHeadIdArray = row.AccountIds.split(",");
      this.selectedAccountHeads = this.AccountHeadDropdown.filter((account) =>
        accountHeadIdArray.includes(account.AccountId.toString())
      );
    }
  }

  Get_Acc_GroupDropdown() {
    this.lmsService.Get_Acc_GroupDropdown({}).subscribe((res: any) => {
      this.groupDropdown = res;
    });
  }

  getAccounthead() {
    this.lmsService.Get_Account_Master({}).subscribe((res: any) => {
      this.AccountHeadDropdown = res;
    });
  }

  // Group selection handler
  onGroupSelect(item: any) {
    // This will automatically update selectedGroups array
    console.log("Selected Groups:", this.selectedGroups);
  }

  // Account Head selection handler
  onAccountHeadSelect(item: any) {
    // This will automatically update selectedAccountHeads array
    console.log("Selected Account Heads:", this.selectedAccountHeads);
  }

  onSaveGroup() {
    // Form validation is handled by template-driven form
    this.showSpinner = true;

    // Get comma-separated strings from selected arrays
    const groupIds = this.selectedGroups
      ? this.selectedGroups.map((element) => element.GroupId).join(",")
      : "";

    const accountHeadIds = this.selectedAccountHeads
      ? this.selectedAccountHeads.map((element) => element.AccountId).join(",")
      : "";

    const formData = {
      Id: this.modelId,
      RatioName: this.groupRationame,
      GroupIds: groupIds || this.negativeid,
      AccountIds: accountHeadIds,
      LoginUserId: this.currentUser.userId,
    };

    console.log("Saving data:", formData);

    this._MasterService.Save_Acc_Group_Ratio_Master(formData).subscribe(
      (result) => {
        this.showSpinner = false;
        this.ACC_Get_Group_Ratio_Master();
        this.OnClose();
        this.snackBar.open(
          "Group Ratio saved successfully!",
          "Close",
          this.configSuccess
        );
      },
      (error) => {
        this.showSpinner = false;
        console.error("Error saving group ratio:", error);
        this.snackBar.open("Error saving group ratio!", "Close", {
          panelClass: "style-error",
          duration: 5000,
          horizontalPosition: "right",
          verticalPosition: "top",
        });
      }
    );
  }

  private resetForm() {
    if (this.form) {
      this.form.resetForm();
    }
    this.selectedGroups = [];
    this.selectedAccountHeads = [];
    this.groupRationame = "";
    this.modelId = 0;
    this.negativeid = null;
  }
}
